import type { ThemeWithoutTokens } from '../theme.types';

export const tableTokens = (theme: ThemeWithoutTokens) =>
  ({
    // spacing
    tableCellPadding: '16px',
    tableClickableCellPadding: '12px',
    tableFirstColumCellPaddingLeft: '32px',
    tableFirstColumClickableCellPaddingLeft: '28px',

    // colors
    tableAlternateRowBackgroundColor: theme.palette.grey50,
    tableRowBackgroundColor: theme.palette.white,

    tableCellSuccessBackgroundColor: theme.palette.green400,
    tableCellSuccessTextColor: theme.palette.darkGrey,
    tableCellWarningBackgroundColor: theme.palette.yellow400,
    tableCellWarningTextColor: theme.palette.darkGrey,
    tableCellDangerBackgroundColor: theme.palette.red400,
    tableCellDangerTextColor: theme.palette.white,
  }) as const;
